/* eslint-disable max-len */
<template>
  <div class="top-nav">
    <Menu mode="horizontal" router>
      <menu-item @click="routeToHome">
        <RSLogo />
        Portal
      </menu-item>
      <menu-item>
        <el-button
          v-if="facility"
          icon="el-icon-search"
          :disabled="searchDialog"
          type="text"
          size="mini"
          @click="() => openSearchDialog()"
        >
        </el-button>
      </menu-item>
      <menu-item>
        <el-select
          v-model="facility"
          :loading="loading"
          no-data-text="No facility found"
          placeholder="Select Facility"
          @change="assignToGlobalValue"
        >
          <el-option
            v-for="item in facilities"
            :key="item._id"
            :label="item.title"
            :value="item._id">
          </el-option>
        </el-select>
      </menu-item>
      <el-submenu class="settings" index="/settings">
        <template slot="title">
          <i class="el-input__icon el-icon-s-tools"></i>
          {{ username }}
        </template>
        <el-menu-item @click="() => routeOthers('settings/profile')">
          <i class="el-input__icon el-icon-user-solid">
            Profile
          </i>
        </el-menu-item>
        <el-menu-item @click="logout">
          <i class="el-input__icon el-icon-switch-button">
            Logout
          </i>
        </el-menu-item>
      </el-submenu>
    </Menu>

    <el-dialog :visible.sync="searchDialog" modal custom-class="searchBar" destroy-on-close @close="value = ''">
      <!-- <el-card :body-style="{backgroundColor: 'transparent'}" shadow="never"> -->
        <el-autocomplete
          ref="searchBar"
          :style="{width: '100%'}"
          prefix-icon="el-icon-search"
          :trigger-on-focus="false"
          v-model="value"
          type="search"
          :fetch-suggestions="searchData"
          name="search"
          placeholder="Search"
          append
          autocomplete="on"
          autofocus
          resize="horizontal"
          @select="searchSelected"
          @input="inputSearch"
        >
        </el-autocomplete>
      <!-- </el-card> -->
    </el-dialog>
  </div>
</template>

<script>
import { Menu, MenuItem, Image } from 'element-ui';
import axios from 'axios';
import RSLogo from './RSLogo.vue';
import { CUSTOMER_API_BASE, UNITS_API_BASE, ADMIN_API_BASE } from '../env';
import { escapeSpecialCharacters } from '../utils/regExp';
import { clearAllSitemapCache } from '../sw-sitemap-register';

axios.interceptors.response.use(undefined, (err) => {
  const { config } = err;
  if (!config || !config.retry) {
    return Promise.reject(err);
  }

  // if (!(message.includes('timeout') || message.includes('Network Error'))) {
  //   return Promise.reject(err);
  // }

  config.retry -= 1;
  const delayRetryRequest = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, config.retryDelay || 1000);
  });
  return delayRetryRequest.then(() => axios(config));
});

export default {
  name: 'TopNav',
  components: { Menu, MenuItem, Image, RSLogo },
  computed: {
    username() {
      return this.$keycloak.tokenParsed.given_name;
    },
  },
  watch: {
    $route(to) {
      const { facility } = to.params;
      if (!facility) {
        this.facility = '';
        this.$root.$data.resetFacilityAction();
        this.$root.$data.resetFacilityDataAction();
      }
      if (this.$root.state.facilities.includes(facility)) {
        this.$root.$data.setFacilityAction(facility);
        this.facility = facility;
        const index = [...this.$root.state.facilities].indexOf(facility);

        if (index >= 0) {
          this.$root.$data.setFacilityDataAction(this.facilities[index]);
        }
      }
    },
  },
  async mounted() {
    // console.log( this.$router.history.current.params )
    this.loading = true;
    await this.fetchLocations();
    this.loading = false;
  },
  methods: {
    openSearchDialog() {
      this.searchDialog = true;
      this.$nextTick(() => {
        this.$refs.searchBar.focus();
      });
    },
    async fetchLocations() {
      try {
        const response = await axios
          .get(`${ADMIN_API_BASE}/facilities`, {
            retry: 25,
            retryDelay: 1000,
            params: {
              limit: 55,
            },
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        this.loading = false;
        // eslint-disable-next-line no-console
        this.facilities = response.data;
        const facilityIds = this.facilities.map(fac => fac._id);
        this.facilityIds = facilityIds;
        this.$root.setFacilities(this.facilityIds);
        const { facility } = this.$router.history.current.params;

        if (facility) {
          this.facility = facility;
          if (!this.facilityIds.includes(facility)) {
            this.facility = '';
            this.$root.$data.resetFacilityAction();
            this.$root.$data.resetFacilityDataAction();
            this.$router.push({ name: 'Not found' });
            return;
          }
          this.$root.$data.setFacilityAction(facility);
          const index = [...this.facilityIds].indexOf(facility);

          if (index >= 0) {
            this.$root.$data.setFacilityDataAction(this.facilities[index]);
          }
        } else {
          const savedFacility = localStorage.getItem('selected_facility');
          if (savedFacility && this.facilityIds.includes(savedFacility)) {
            this.facility = savedFacility;
            this.$root.$data.setFacilityAction(savedFacility);
            const index = [...this.facilityIds].indexOf(savedFacility);
            if (index >= 0) {
              this.$root.$data.setFacilityDataAction(this.facilities[index]);
            }
            this.$router.push(`/dashboard/${savedFacility}`);
          } else {
            this.facility = '';
            this.$root.$data.resetFacilityAction();
            this.$root.$data.resetFacilityDataAction();
          }
        }
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    routeToHome() {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/${facility}`) {
        this.$router.push(`/dashboard/${facility}`);
        return;
      }
      this.$router.push('/');
    },
    async searchData(searchText, callback) {
      try {
        const searchValue = escapeSpecialCharacters(searchText);
        this.loading = true;
        if (!searchText && !callback) return;

        if (!searchText && callback) {
          callback([]);
        }

        const customers = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/get/all`, {
          params: { fullname: searchValue, facility: this.facility, email: true },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        const units = await axios.get(`${UNITS_API_BASE}`, { params: {
          unitname: searchValue,
          facility: this.facility,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        } });
        this.result = customers.data;
        this.units = units.data;
        this.units.forEach((unit) => {
          const [foundFacility] = this.facilities.filter(fac => fac._id === unit.facility);

          if (foundFacility.code) {
            // eslint-disable-next-line no-param-reassign
            unit.facilityCode = foundFacility.code;
          }
        });

        this.loading = false;
        if (callback) {
          console.log([...this.result.map(cus => ({ value: `Customer: ${cus.company}`})), ...this.units.map(unit => ({ value: `Unit: ${unit.name}` }))]);
          callback([...this.result.map(cus => ({ value: `Customer: ${cus.company}`, customer: true, id: cus._id })), ...this.units.map(unit => ({ value: `Unit: ${unit.name}`, unit: true, id: unit._id, facility: unit.facility }))]);
        }
      } catch (err) {
        this.loading = false;
        this.error = err.message ? err.message : err.response.data;
      }
    },
    inputSearch(item) {
      console.log(item)
    },
    searchSelected(item) {
      if (item.customer) {
        this.$router.push({ name: this.facility ? 'Facility Customer' : 'Customer', params: { id: item.id, ...(this.facility ? { facility: this.facility } : {}) } });
      }

      if (item.unit) {
        this.$router.push({ name: 'Facility Unit', params: { facility: item.facility, unit: item.id } });
      }

      this.value = '';
      this.searchDialog = false;
    },
    routeToCustomer(customerId) {
      if (customerId.startsWith('unit')) {
        const unitId = customerId.split('unit').pop();
        const [unit] = this.units.filter(item => item._id === unitId);
        if (!this.facility) {
          this.facility = unit.facility;
        }

        this.$router.push({ name: 'Facility Unit', params: { facility: unit.facility, unit: unitId } });
        this.result = [];
        this.units = [];
        return;
      }
      if (this.$router.name !== 'Customer' || this.$router.name !== 'Facility Customer') {
        this.$router.push({ name: this.facility ? 'Facility Customer' : 'Customer', params: { id: customerId, ...(this.facility ? { facility: this.facility } : {}) } });
        this.result = [];
        this.units = [];
        return;
      }
      this.$router.push({ name: this.facility ? 'Facility Customer' : 'Customer', params: { id: customerId, ...(this.facility ? { facility: this.facility } : {}) } });
      this.result = [];
      this.units = [];
    },
    routeOthers(index) {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/${index}/${facility}`) {
        this.$router.push(`/${index}/${facility}`);
        return;
      }
      this.$router.push(`/${index}`);
    },
    logout() {
      // Drop cached private sitemap/unit data so it cannot be served to a
      // different user who logs in on this same browser profile.
      clearAllSitemapCache();
      this.$keycloak.logout();
    },
    profile() {
      this.$router.push({ name: 'Manager Profile' });
    },
    assignToGlobalValue(facilityId) {
      // Vue.prototype.$facility = facility;
      this.$root.setFacilityAction(facilityId);
      const index = [...this.facilityIds].indexOf(facilityId);

      if (index >= 0) {
        this.$root.$data.setFacilityDataAction(this.facilities[index]);
      }
      
      localStorage.setItem('selected_facility', facilityId);
      
      const { facility } = this.$router.history.current.params;
      if (facility) {
        this.$router.replace({ params: { facility: facilityId } });
        return;
      }

      const { name } = this.$router.history.current;
      this.$router.push({ name: `Facility ${name}`, params: { ...this.$router.history.current.params, facility: facilityId } });
    },
  },
  data() {
    return {
      searchText: '',
      value: '',
      result: () => [],
      units: () => [],
      loading: true,
      error: '',
      facilities: [],
      facility: '',
      facilityIds: [],
      searchDialog: false,
    };
  },
};
</script>

<style scoped>
.settings {
  float: right;
}

</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue